import React, {useState, useEffect} from 'react';
import {Modal, Row, Col} from 'antd';
import ProductImagesCarousel from './ProductImagesCarousel';
import {setSelectedProductId} from '../../redux/slices/selectProductId';

import DownloadButton from '../download/DownloadButton';
import ArrowButton from "./modal/ArrowButton";
import { useBrowser } from '../../contexts/BrowserContext';
import LikeButton from "./modal/LikeButton";
import ShowMoreButton from "./modal/ShowMoreButton";
import ShowMoreSection from "./modal/ShowMoreSection";
import RadioGroupOptions from "./modal/RadioGroupOptions";
import AddToProjectSection from "./modal/AddToProjectSection";
import { GetClientType } from '../../config';
import { useSelector } from "react-redux";
import ColorAndDownloadAssets from './modal/ColorAndDownloadAssets';
import getProfileType from '../../helpers/getProfileType';


const ProductModal = ({
                          product,
                          open,
                          setOpen,
                          data,
                          selectedIndex,
                          setSelectedIndex,
                          likedItems,
                          toggleLike
                      }) => {

    const [showMoreOptions, setShowMoreOptions] = useState(false);
    const [profileType, setProfileType] = useState('all');
    const [indexAssets, setIndexAssets] = useState(0);
    const { browser } = useBrowser();
    const [renderOptions, setRenderOptions] = useState({
        psb: "planar",
        uvw: 50,
        hue_shift: 0,
        saturation: 0,
        brightness: 0,
        contras: 0
    });


    const handleCloseModal = () => {
        setOpen(false);
        setSelectedIndex(null);
    };

    useEffect(() => {
        if (product != null && GetClientType() == "3dmax") {
            switch (renderOptions.psb) {
                case "planar":
                    browser.planar(product);
                    break;
                case "spherical":
                    browser.spherical(product);
                    break;
                case "box":
                    browser.box(product);
                    break;
                default:
                    break;
            }
        }
    }, [renderOptions.psb]);

 useEffect(() => {
if (product != null) {
    setProfileType(getProfileType(product))
}
    }, [product]);

    return (
       product != null &&  <Modal
       title={product?.name || ''}
       open={open}
       onCancel={handleCloseModal}
       footer={null}
       className='white-modal'
       width={590}
       styles={{mask: {backdropFilter: 'blur(10px)'}}}
   >
           <>
               <Row>
                   <Col xs={24} sm={12} md={11} lg={11}>

                       <ArrowButton open={open} data={data} selectedIndex={selectedIndex}
                                    setSelectedIndex={setSelectedIndex}
                                    setSelectedProductId={setSelectedProductId}/>
                       <div className='section-left'>
                           <h2 className='modal-title' style={{fontSize:'18px' , fontWeight:'700'}}>{product?.name}</h2>
                           {/* <ColorAndDownloadAssets productModalData={product} setIndexAssets={setIndexAssets}/> */}
                           <div className='download-project' style={{display:'flex' , alignItems:"flex-start" , justifyContent:'flex-start' , gap:'8px'}}>
                               <DownloadButton indexAssets={indexAssets} className="download-btn" product={product}/>
                               <LikeButton data={data} modalData={product} likedItems={likedItems}
                                           toggleLike={toggleLike}/>
                           </div>
                           <AddToProjectSection selectedProduct={product} profileType={profileType}
                                                browser={browser}/>

                           <RadioGroupOptions profileType={profileType} selectedProduct={product}
                                              render={{renderOptions, setRenderOptions}}
                                              browser={browser}/>
                       </div>
                   </Col>
                   <Col xs={24} sm={12} md={13} lg={13} className='section-right'>
                       <ProductImagesCarousel selectedProduct={product}/>
                   </Col>
               </Row>

               <ShowMoreSection profileType={profileType} showMoreOptions={showMoreOptions}
                                selectedProduct={product} renderOptions={renderOptions}
                                setRenderOptions={setRenderOptions} browser={browser}/>

               <ShowMoreButton showMoreOptions={showMoreOptions} setShowMoreOptions={setShowMoreOptions}
                               profileType={profileType}/>
           </>
   </Modal>
    );
};

export default ProductModal;
